import React from 'react';
import {Page} from "components/ui";
import {can, translate} from "utils/helpers";
import {useServiceContext} from "context/ServiceContext";
import ServiceTable from "pages/service/components/ServiceTable";
import ServiceFormModal from "pages/service/components/ServiceFormModal";
import ServiceFilter from "pages/service/components/ServiceFilter";

function ServicePage(props) {

    const {permission, modal, handleModal} = useServiceContext();

    return (
        <Page
            action={
                <>
                    {can(permission + '.create') && (
                        <button className="btn btn--primary" onClick={() => handleModal('form', true)}>
                            {translate('button.Add')}
                        </button>
                    )}
                </>
            }
        >
            <ServiceFilter/>
            <ServiceTable/>
            {(can(permission + '.create') || can(permission + '.update')) && (
                <>
                    {modal.form && <ServiceFormModal/>}
                </>
            )}
        </Page>
    );
}

export default ServicePage;
